export const usefulMethodsMixin = {
  methods: {
    sumKey: function (array, property) {
      return array
        .filter(({ deleted }) => deleted !== true) // remove deleted payment from the sum
        .reduce(function (a, b) {
          return +a + +b[property];
        }, 0);
    },
    formatDateForDatabase: function (dateString) {
      // Vérification si la date est déjà au format YYYY-MM-DD
      const regex = /^\d{4}-\d{2}-\d{2}$/;
      if (regex.test(dateString)) {
        return dateString;
      }

      const parts = dateString.split('/');
      if (parts.length !== 3) {
        return ''; //
      }
      const [day, month, year] = parts;
      return `${year}-${month}-${day}`;
    },
  },
};
